import BarChart from "./barChart.container";
export default BarChart